import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable()
export class DocumentProofService {
  constructor(private http: HttpClientService) {}

  public show(id): Observable<any> {
    return this.http.get("/api/document_proofs/" + id).pipe(tap((_) => console.log("DocumentProofService.show: Ok.")));
  }
  public fullData(id, document_validation_id): Observable<any> {
    const options = {
      params: { document_validation_id },
    };
    return this.http
      .get(`/api/document_proofs/${id}/full_data`, options)
      .pipe(tap((_) => console.log("DocumentProofService.fullData: Ok.")));
  }
  public notOpenBanking(id): Observable<any> {
    const options = {
      params: { id },
    };
    return this.http
      .get("/api/document_proofs/not_open_banking", options)
      .pipe(tap((_) => console.log("DocumentProofService.noOpenBanking: Ok.")));
  }
  public addressProofSurvey(id): Observable<any> {
    const options = {
      params: { application_id: id },
    };
    return this.http
      .get(`/api/applications/${id}/address_proof_surveys`, options)
      .pipe(tap((_) => console.log("DocumentProofService.automaticLocksAddressProof: Ok.")));
  }
  public automaticLocksIdentity(id): Observable<any> {
    const options = {
      params: { application_id: id },
    };
    return this.http
      .get(`/api/applications/${id}/address_proof_surveys/identity`, options)
      .pipe(tap((_) => console.log("DocumentProofService.automaticLocksIdentity: Ok.")));
  }

  public automaticLocksIncomes(id): Observable<any> {
    const options = {
      params: { application_id: id },
    };
    return this.http
      .get(`/api/applications/${id}/address_proof_surveys/incomes_validations`, options)
      .pipe(tap((_) => console.log("DocumentProofService.automaticLocksIncomes: Ok.")));
  }

  public addressProofSurveyUpdate(id, full_name): Observable<any> {
    const options = { application_id: id, full_name: full_name };
    return this.http
      .put(`/api/applications/${id}/address_proof_surveys/update_cfe`, options)
      .pipe(tap((_) => console.log("DocumentProofService.automaticLocksAddressProof: Ok.")));
  }

  public validationsHistory(id): Observable<any> {
    const options = {
      params: { application_id: id },
    };
    return this.http
      .get(`/api/applications/${id}/address_proof_surveys/validations_history`, options)
      .pipe(tap((_) => console.log("DocumentProofService.validationsHistory: Ok.")));
  }
}
